import { toAbsoluteUrl } from '../../utils/assetHelper'
import css from './footer.module.scss'
import { Link, NavLink } from 'react-router-dom'
import FooterLogo from '../../assets/v1/logo.png'


const InstagramIcon = () => (
    <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.3" cy="6.7" r="0.8" fill="currentColor" stroke="none" />
    </svg>
);

const XIcon = () => (
    <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor">
        <path d="M18.9 3H21l-6.9 7.9L22 21h-6.2l-4.8-6.3L5.5 21H3.4l7.4-8.4L2 3h6.3l4.3 5.8L18.9 3Zm-2.2 16h1.7L7.4 4.9H5.6L16.7 19Z" />
    </svg>
);

const LinkedinIcon = () => (
    <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor">
        <path d="M6.94 8.5H3.56V20h3.38V8.5ZM5.25 3a1.97 1.97 0 1 0 0 3.94A1.97 1.97 0 0 0 5.25 3ZM20.44 13.01c0-3.42-1.82-5.01-4.25-5.01-1.96 0-2.84 1.08-3.33 1.84V8.5H9.48V20h3.38v-6.39c0-1.68.32-3.31 2.4-3.31 2.05 0 2.08 1.92 2.08 3.42V20h3.38v-6.99Z" />
    </svg>
);

const socialMedia = [
    {
        icon: InstagramIcon,
        link: 'https://www.instagram.com/identifyn_super_resolution/'
    },
    {
        icon: XIcon,
        link: 'https://twitter.com/IdentifynLLC'
    },
    {
        icon: LinkedinIcon,
        link: 'https://www.linkedin.com/company/identifyn'
    }
]

export const Footer = () => {
    return (
        <>
            <footer className={css.footer}>
                <div className={css.content}>
                    <div>
                        <img src={FooterLogo} alt="logo" className={css.footerLogo} />
                        <p className={css.description}>
                            Delivering unprecedented power, speed, and access to multimodal super resolution microscopy, reagents, applications, and discovery.
                        </p>
                        <p className={css.copyright}>© Copyright 2026 GMD12 LLC.</p>
                    </div>
                    <div>
                        <div className={css.footerLinkHeader}>How to Buy</div>
                        <div className={css.links}>
                            <Link to='https://www.thermofisher.com' target='_blank' className={css.link}>Thermofisher</Link>
                            <NavLink className={css.link} to='/v1/oem'>OEM / Bulk Sales</NavLink>
                        </div>
                    </div>

                    <div>
                        <div className={css.footerLinkHeader}>Support</div>
                        <div className={css.links}>
                            <NavLink className={css.link} to='/contact'>Technical Support</NavLink>
                            <NavLink className={css.link} to='/v1/identifyn-methods'>Identifyn Methodologies</NavLink>
                            <NavLink className={css.link} to='/v1/teams'>Team</NavLink>
                        </div>
                    </div>

                    <div>
                        <div className={css.footerLinkHeader}>Legal</div>
                        <div className={css.links}>
                            <NavLink className={css.link} to='/v1/terms-and-conditions-of-use'>Terms and Conditions of Use</NavLink>
                            <NavLink className={css.link} to='/v1/terms-and-conditions-of-sale'>Terms and Conditions of Sale</NavLink>
                            <NavLink className={css.link} to='/v1/privacy-policy'>Privacy Policy</NavLink>
                            <NavLink className={css.link} to='/v1/cookie-policy'>Cookie Policy</NavLink>
                            <NavLink className={css.link} to='/v1/intellectual-property'>Intellectual Property</NavLink>
                        </div>
                    </div>
                </div>
                <div className={css.contentDivider}>
                    <div className={css.content}>
                        <div>
                            <div className={css.footerLinkHeader}>STAY CONNECTED</div>
                            <div className={css.footerIcons}>
                                {socialMedia.map((icon, i) => (
                                    <button key={i} className={css.footerLink}>
                                    <a href={icon.link} target='_blank' rel='noreferrer'>
                                        {icon.icon()}
                                    </a>
                                    </button>
                                ))}
                            </div>
                            {/* <div className={css.appAvailability}>
                                <p>App availability</p>
                                <div className={css.appIcons}>
                                    <Link className={css.iconLink} to='https://apps.apple.com/us/app/identifyn/id6504354303'>App Store</Link>
                                    <Link className={css.iconLink} to='https://play.google.com/store/apps/details?id=com.identifyn.app&hl=en_US'>Google Play</Link>
                                </div>
                            </div> */}
                        </div>
                        <div>
                            <div className={css.footerLinkHeader}>IDENTiFYN® LLC</div>
                            <div className={css.information}>
                                <Link to='tel:+19415290647'>941.529.0647</Link>
                                <Link to='mailto:contact@identifyn.com'>contact@identifyn.com</Link>
                            </div>
                        </div>

                        <div>
                            <div className={css.footerLinkHeader}>Corporate Address</div>
                            <div className={css.information}>
                                <p>2055 Wood Street, Suite 206
                                    Sarasota, FL 34237
                                </p>
                            </div>
                        </div>

                        <div>
                            <div className={css.footerLinkHeader}>Laboratory Address</div>
                            <div className={css.information}>
                                <p>
                                    2055 Wood Street, Suite 102
                                    Sarasota, FL 34237
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={css.footerBottom}>
                    Resolution defines truth. Everything else is approximation.
                </div>
            </footer>
        </>
    )
}
